import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Flame = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M12.56625,17.4003125 C10.4880978,18.156875 7.79657609,17.5175 6.72440217,15.9890625 C9.01190217,15.584375 10.5239674,14.308125 11.3199457,12.1965625 C11.5915761,13.2878125 11.2439674,14.28625 10.7691848,15.4140625 C12.247663,14.461875 13.0782065,13.2915625 13.3703804,11.7453125 C13.66125,10.2065625 13.192663,8.8571875 12.2933152,7.583125 C14.1011413,7.8015625 15.7902717,9.83 16.0619022,12.059375 C16.3335326,14.2875 14.8367935,16.5746875 12.56625,17.4003125 M14.970163,6.4590625 C14.2224457,5.875625 13.4016848,5.3759375 12.6950543,4.7515625 C11.2739674,3.4953125 10.5758152,1.999375 11.4050543,0 C11.219837,0.1021875 11.1334239,0.1465625 11.0505978,0.1965625 C8.02744565,2.0075 6.57309783,4.6353125 6.71233696,8.0690625 C6.74951087,8.9978125 6.88679348,9.921875 6.98396739,10.914375 C5.48755435,9.721875 5.30853261,8.1259375 5.28570652,6.355625 C5.0561413,6.6090625 4.91168478,6.7578125 4.77961957,6.9171875 C3.27211957,8.726875 2.92483696,10.831875 3.01255435,13.085625 C3.21798913,18.4209375 9.45538043,21.7496875 14.2035326,19.0321875 C18.9200543,16.331875 19.3178804,9.8553125 14.970163,6.4590625"
				id="flame"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Flame.propTypes = {
	color: PropTypes.string,
};

export default Flame;
